// extracted by mini-css-extract-plugin
export var aboveInput = "_n2-0";
export var actionButton = "_n2-5";
export var actionButtonContainer = "_n2-1";
export var actionIcon = "_n2-6";
export var aiInfoContainer = "_n2-2";
export var attachmentWrapper = "_n2-7";
export var bold = "_n2-3";
export var checkIcon = "_n2-8";
export var clickingRecipientBar = "_n2-11";
export var commentThreadSwitch = "_n2-a";
export var draftImage = "_n2-b";
export var draftImageContainer = "_n2-c";
export var draftImages = "_n2-e";
export var editButton = "_n2-g";
export var editor = "_n2-f";
export var editorContainer = "_n2-y";
export var editorErrorTooltipWrapper = "_n2-9";
export var headerDivider = "_n2-h";
export var icon = "_n2-i";
export var info = "_n2-j";
export var internal = "_n2-n";
export var internalDivider = "_n2-k";
export var internalMessage = "_n2-l";
export var messageInputCard = "_n2-m";
export var messageInputForm = "_n2-o";
export var messageInputFormInternal = "_n2-p";
export var options = "_n2-q";
export var publicMessageCustomer = "_n2-s";
export var publicMessageMerchant = "_n2-r";
export var removeImageButton = "_n2-d";
export var replyButtons = "_n2-t";
export var showSignatureButton = "_n2-u";
export var spinner = "_n2-v";
export var verticalButtonDivider = "_n2-4";
export var visibilitySelector = "_n2-w";
export var warning = "_n2-x";
export var wrappingText = "_n2-z";
export var writingInternalNoteTopBorder = "_n2-10";